export default "__VITE_ASSET__BswJzFkV__"